import CheckoutCardView from "./view";
import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import { paymentCard, setUser } from "@/redux/ducks/user";
import { getIsValidString, validateCPF } from "@/utils/functions";
import useRedirect from "@/hooks/useRedirect";
import { useNavigate } from "react-router-dom";
import useCybersourceService from "@/hooks/useCybersourceService";
import React, { useEffect, useState } from "react";
import { PaymentCardAction } from "@/redux/sagas/payment/card";

export default function CheckoutCard() {
  useRedirect("checkout/card");

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const { adicionarCyberSourceScripts, getSessionId } = useCybersourceService();

  useEffect(() => {
    adicionarCyberSourceScripts();
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const goBack = () => navigate(-1);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(setUser({
      ...user,
      card: {
        ...user?.card,
        [name]: value,
      }
    }));
  }

  const getIsDisabled = () => {
    const card = user?.card;
    if (!validateCPF(card?.cardDocument ?? "")
      || !getIsValidString(card?.cardName)
      || String(card?.cardExpiration ?? "").length < 7
      || String(card?.cardNumber ?? "").length < 18) return true;
    return false;
  }

  const handlePayment = (success: boolean) => {
    setIsLoading(false);

    if (!success) {
      setError(true);
      return;
    }

    navigate('/checkout/finished');
  }

  const payment = () => {
    if (isLoading) return;

    setIsLoading(true);

    const visitorId = getSessionId();
    
    dispatch(
      paymentCard({
        ...user,
        visitorId,
        callback: handlePayment,
      } as PaymentCardAction['payload'])
    );

  }

  const submit = () => {
    if (getIsDisabled()) return;
    
    payment();
  }

  return (
    <CheckoutCardView
      onChange={onChange}
      card={user?.card}
      submit={submit}
      goBack={goBack}
      isDisabled={getIsDisabled()}
      isLoading={isLoading}
      error={error}
    />
  );
}